import _ from "lodash"
import { ImmutableBehaviorSubject as BehaviorSubject } from "data/lib/immutable-behavior-subject"

import Client from "data/_client"
import { ApiResult } from "data/interface/api"
import notificationService from "data/notification"
import { PromiseWatch } from "./lib/promise-helpers"

export type Recovery = {
  propertyid: number
  recoveryid: number
}
// private module logic //

const id: string = "namedRecovery"
const initialState: ApiResult<Recovery[]> = { id, state: "init", value: [] }
const namedRecoveryStream = new BehaviorSubject<ApiResult<Recovery[]>>(initialState)
const namedRecoveryEventStream = new BehaviorSubject<{ type: string; payload: any }>({
  type: '',
  payload: {}
})

let namedRecoveryMap = {}
const _fetches_ = PromiseWatch()

function clear(): void {
  namedRecoveryStream.next({ id, state: 'ok', value: [] })
  namedRecoveryMap = {}
}

function get(recoveryid: number): Recovery {
  return namedRecoveryMap[recoveryid]
}

function fetchNamedRecoveries(
  propertyId: number,
  limit: number = 0,
  offset: number = 0
): Promise<Recovery[] | { message: string }> {
  if (_fetches_.has(propertyId)) return _fetches_.first(propertyId)

  clear()
  namedRecoveryStream.next({ id, state: 'busy', value: namedRecoveryStream.getValue().value })

  let url = `recovery?propertyid=eq.${propertyId}&order=type.asc,code.asc.nullsfirst`
  if (limit && offset >= 0) {
    url = `recovery?propertyid=eq.${propertyId}&limit=${limit}&offset=${offset}&order=type.asc,code.asc.nullsfirst`
  }

  return _fetches_.watch(propertyId, Client.get(url)
  .then((records: Recovery[]) => {
    _.forEach(records, (namedRecoveries) => (namedRecoveryMap[namedRecoveries.recoveryid] = namedRecoveries))
    // merge results unique by recoveryid
    namedRecoveryStream.next({ id, state: 'ok', value: records })
    return records
  })
  .catch((err: { message: string }) => {
    notificationService.notify({ type: 'danger', message: err.message, dismiss: 5000 })
    return err
  }))
}

// public module interface //

const namedRecoveryService = {
  stream: () => namedRecoveryStream.asObservable(),
  value: () => namedRecoveryStream.getValue().value,
  eventStream: () => namedRecoveryEventStream.asObservable(),
  get,
  fetchNamedRecoveries
}

export default namedRecoveryService
